import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsEnum } from 'class-validator';
import { PromotionDiscountLevelEnum, PromotionSubTypeEnum, PromotionTypeEnum } from '../../common';
import { PromotionExternalExposeGroup } from '../interface';
import { PromotionDiscountDto } from './PromotionDiscountDto';
import { PromotionTargetElementDto } from './PromotionTargetElementDto';
export class PromotionCartPromotionElementDto {
    isCheckBased() {
        return PromotionDiscountLevelEnum.CHECK_BASED === this.discount.level;
    }
}
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "uuid", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "title", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "subtitle", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    IsEnum(PromotionTypeEnum, { always: true }),
    ApiProperty({ enum: PromotionTypeEnum }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "posGuid", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    IsEnum(PromotionSubTypeEnum, { always: true }),
    ApiProperty({ enum: PromotionSubTypeEnum }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "subtype", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => Number }),
    __metadata("design:type", Number)
], PromotionCartPromotionElementDto.prototype, "percentage", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    Type(() => PromotionDiscountDto),
    ApiProperty({ type: () => PromotionDiscountDto }),
    __metadata("design:type", PromotionDiscountDto)
], PromotionCartPromotionElementDto.prototype, "discount", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    Type(() => PromotionTargetElementDto),
    ApiPropertyOptional({ type: () => PromotionTargetElementDto }),
    __metadata("design:type", Array)
], PromotionCartPromotionElementDto.prototype, "elements", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => Boolean }),
    __metadata("design:type", Boolean)
], PromotionCartPromotionElementDto.prototype, "isCumulative", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "image", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => Object }),
    __metadata("design:type", Object)
], PromotionCartPromotionElementDto.prototype, "loyaltyInfo", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], PromotionCartPromotionElementDto.prototype, "promoCode", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => Boolean }),
    __metadata("design:type", Boolean)
], PromotionCartPromotionElementDto.prototype, "isTemplate", void 0);
//# sourceMappingURL=PromotionCartPromotionElementDto.js.map